// Styles for filter elements

export const filterStyles = {
    inline: {display: 'inline-block', verticalAlign: 'top', marginRight: '1em'},
    break: {
        display: 'block',
        width: '100%',
        height: 0,
        border: 'none',
        margin: 0,
        paddingBottom: '1em',
    },
    calendarInput: {
        border: 'none',
        borderBottom: '1px solid rgba(33, 33, 33, 0.1)',
        fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
        fontSize: 16,
        textTransform: 'uppercase',
        outline: 'none',
        padding: '3px 0 3px 0',
        width: '100%'
    },
    calendarInputLabel: {
        color: 'rgba(33, 33, 33, 0.3)',
        fontSize: 12,
        textTransform: 'none'
    },
    dateInput: {
        display: 'flex',
        flexDirection: 'column',
        width: '30%',
        marginTop: 12,
        marginRight: '2em'
    },
    dateInputWide: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: 12,
        maxWidth: 300
    },
    fieldInstructions: {margin: '2em 0 0 0'},
    filterContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap'
    },
    filterContainerLeft: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'left',
        flexWrap: 'wrap'
    },
    filterContainerInline: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'left',
        flexWrap: 'nowrap'
    },
    filterRow: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center'
    },
    inlineText: {
        display: 'inline-block',
        verticalAlign: 'bottom',
        margin: '0px 13px 13px 0',
    },
    inlineTextSmall: {
        display: 'inline-block',
        width: 180,
        verticalAlign: 'bottom',
        margin: '0px 13px 13px 0',
    },
    reportFilter: {
        display: 'inline-block',
        maxWidth: 360,
        verticalAlign: 'top',
        marginRight: '1em'
    },
    reportFilterContainer: {
        display: 'inline-block',
        verticalAlign: 'top',
        marginRight: '1em'
    },
    selectInput: {width: '30%', minWidth: 50, marginTop: 0, marginRight: '1em'},
    selectInputInline: {display: 'inline-block', width: '30%', minWidth: 180, marginTop: 0, marginRight: '1em'},
    selectInputTime: {width: 80, marginTop: 0, marginRight: '1em'},
    selectInputSmall: {
        minWidth: 50,
        maxWidth: 150,
        marginTop: 0,
        marginLeft: '1em',
    },
    selectInputMedium: {width: '30%', minWidth: 180, marginTop: 0, marginRight: '1em'},
    selectInputWide: {minWidth: 300, marginTop: 0},
    selectInputFull: {width: '80%', minWidth: '80%', marginTop: 0},
    selectInputMultilineFull: {width: '80%', minWidth: '80%', marginTop: 0},
    selectInputMultiline: {width: '90%', minWidth: '90%', marginTop: 0},
};



// WEBPACK FOOTER //
// ./src/Fuse/shared/styles-filter.js